module.exports = __webpack_public_path__ + "static/sponsorship_img-08-a-59f6d173a61d8a301719dd94d201a4ed.jpg";